import { useSelector } from 'react-redux';
import scope from './scope';


export const useTradeHistoryData = () => {
  return useSelector(state => state[scope]['tradeHistoryData']);
};

export const useFetchingTradeHistoryData = () => {
  return useSelector(state => state[scope]['fetchingTradeHistoryData']);
};


export const useTradeHistoryRowData = () => {
  return useTradeHistoryData();
}


export const useSecurityAttributesMap = () => {
  /*
  const absoluteAnalyticsData = useAnalyticsData(SummaryType.ABSOLUTE);
  const relativeAnalyticsData = useAnalyticsData(SummaryType.RELATIVE);
  return useMemo(() => {
    const attributesMap = new Map();
    [
      ...(absoluteAnalyticsData?.securityAttributes ?? []),
      ...(relativeAnalyticsData?.securityAttributes ?? [])
    ].forEach((securityAttribute = {}) => {
      const { primaryKey = {} } = securityAttribute;
      attributesMap.set(primaryKey?.securityId, securityAttribute);
    });
    return attributesMap;
  }, [absoluteAnalyticsData, relativeAnalyticsData]);
  */
};
